import React from "react";
import useAuth from "../../../hooks/useAuth";
import { UserType } from "../../../utils/enum";
import CompanyInformation from "../components/CompanyInformation";
import UserInformation from "../components/UserInformation";
import About from "../components/About";

// The page anyone opening a CLIENT lands on: the profile display only, no tabs, with the
// same rules about who may read which part that the tabbed profile applied.
const ClientProfile = ({ user, refetchMe }) => {
  const { auth, authRole } = useAuth();
  const isSelfView = auth?.user?.id === user?.id;

  // Which company a client works for is internal to Tech Domain and its clients; anyone
  // still sees their own.
  const canSeeCompanyInfo =
    authRole === UserType.ADMIN || authRole === UserType.CLIENT || isSelfView;

  return (
    <div className="grid grid-cols-1">
      <div>
        {/* Company Info leads, then the person's own details, then the rest. */}
        {canSeeCompanyInfo && <CompanyInformation company={user?.company} />}

        <UserInformation
          refetchMe={refetchMe}
          canEdit={authRole === UserType.ADMIN}
          userInfo={{
            userId: user?.id,
            firstName: user?.firstName,
            lastName: user?.lastName,
            name: `${user?.firstName || ""} ${user?.lastName || ""}`.trim(),
            email: user?.email,
            phoneNumber: user?.phoneNumber,
            createdAt: user?.createdAt,
            lastActive: user?.lastActive,
          }}
        />

        <About description={user?.description} />
      </div>
    </div>
  );
};

export default ClientProfile;
